/**
 * KAN-830 PR 10 (KAN-736 D33, plan §1) — the web flag for the campaign
 * surface. Default OFF: no Campaigns navigation entry, no command-palette
 * entry, no "Type unverified" label, and (codex r1 on PR 1393) no campaign
 * routes, no campaign pages and no actor-to-campaign replacement. The flag is
 * enforced where each thing renders (routes, pages, the label components),
 * not only in navigation. The API adds its own gate: nothing campaign-shaped
 * is served unless the campaign model is authoritative.
 *
 * Read at call time (not module load) so tests can flip it with vi.stubEnv.
 */
export function campaignsSurfaceEnabled(): boolean {
  return import.meta.env.VITE_CAMPAIGNS_SURFACE_ENABLED === 'true'
}
